'use client';

import { useEffect } from 'react';

import TakedaError from '../lib/components/takedaError/TakedaError';
import { env } from '../lib/env';

export const Error = (props: { error: Error }) => {
	const error = !env.isProduction ? props.error : 'Unknown error';

	useEffect(() => {
		if (env.isProduction) {
			// eslint-disable-next-line no-console
			console.error(error);
		}
	}, [error]);

	return <TakedaError error={error} />;
};

export default Error;
